import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/admin')({
  component: RouteComponent,
  beforeLoad: async ({ context: { session } }) => {
    if (!session.user.role?.includes("super_admin")) {
      throw redirect({ to: '/' })
    }
    return { session };
  },
})

function RouteComponent() {
  return (
    <Outlet />
  );
}
